// extracted by mini-css-extract-plugin
export default {"root":"PlasmicMenuSelectStack_root__gQdfH","roothidden":"PlasmicMenuSelectStack_roothidden__wgKBm"};